export const PAGES = {
  MAIN_PAGE: 'mainPage',
  VALUE_PAGE: 'valuePage'
};

export const VALUE_TYPES = [
  'email',
  'text',
  'text_area',
  'number',
  'text_array',
  'email_credential_dropdown',
  'cal_credential_dropdown',
  'cal_event_dropdown',
  'pcm_question_key',
  'pcm_question',
  'pcm_answer_type_dropdown',
  'pcm_answer_value'
];
